<template>
  <div :class="{ 'blur-content': isLoading }">
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="Company"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            ">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">Detail {{ $t("companyTxt") }}</h6>
                  <button class="btn btn-light float-end" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{ this.forms.create_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.update_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>



                  </div>

                </div>

                <div class="card-body">



                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->
                  <!-- <form class="forms-sample" @submit.prevent="submitData" method="POST"> -->
                  <div class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "></div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t("company_type_txt")
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input type="text" class="form-control" id="company_type" :placeholder="$t('company_type_txt')"
                        v-model="forms.company_type" readonly />
                      <div v-if="errors.company_type">
                        <div v-for="error in errors.company_type" :key="error" class="alert alert-primary" role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t("companyCode")
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input type="text" class="form-control" id="code" :placeholder="$t('companyCode')"
                        v-model="forms.code" readonly />
                      <div v-if="errors.code">
                        <div v-for="error in errors.code" :key="error" class="alert alert-primary" role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t("companyName")
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input type="text" class="form-control" id="name" :placeholder="$t('companyName')"
                        v-model="forms.name" readonly />
                      <div v-if="errors.name">
                        <div v-for="error in errors.name" :key="error" class="alert alert-primary" role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Email</label>
                    </div>
                    <div class="col-lg-8">
                      <input type="text" class="form-control" id="country" placeholder="Email" v-model="forms.email"
                        readonly />
                      <div v-if="errors.email">
                        <div v-for="error in errors.email" :key="error" class="alert alert-primary" role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Sap Code</label>
                    </div>
                    <div class="col-lg-8">
                      <input type="text" class="form-control" id="sap_code" placeholder="SAP CODE"
                        v-model="forms.sap_code" disabled />
                      <div v-if="errors.sap_code">
                        <div v-for="error in errors.sap_code" :key="error" class="alert alert-primary" role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">SF Code</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="sf_code"
                          placeholder="SF CODE"
                          v-model="forms.sf_code"
                          disabled
                        />
                        <div v-if="errors.sf_code">
                          <div
                            v-for="error in errors.sf_code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Status</label>
                      </div>
                      <div class="col-lg-8">

                        <select class="form-control" name="status" id="status" v-model="forms.status" disabled>
                            <option value="active">Active</option>
                            <option value="deactive">Deactive</option>
                        </select>

                        <div v-if="errors.roleId">
                          <div
                            v-for="error in errors.roleId"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Country</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="country"
                          placeholder="Country"
                          v-model="forms.country"
                          disabled
                        />
                        <div v-if="errors.country">
                          <div
                            v-for="error in errors.country"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">State</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="state"
                          placeholder="state"
                          v-model="forms.state"
                          disabled
                        />
                        <div v-if="errors.state">
                          <div
                            v-for="error in errors.state"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">City</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="city"
                          placeholder="City"
                          v-model="forms.city"
                          disabled
                        />
                        <div v-if="errors.city">
                          <div
                            v-for="error in errors.city"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Postal Code</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="postal_code"
                          placeholder="Postal Code"
                          v-model="forms.postal_code"
                          disabled
                        />
                        <div v-if="errors.postal_code">
                          <div
                            v-for="error in errors.postal_code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Tax</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="tax"
                          placeholder="Tax"
                          v-model="forms.tax"
                          disabled
                        />
                        <div v-if="errors.tax">
                          <div
                            v-for="error in errors.tax"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Location Reference</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="tax"
                          placeholder="Tax"
                          v-model="forms.location_ref"
                          disabled
                        />
                        <div v-if="errors.location_ref">
                          <div
                            v-for="error in errors.location_ref"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div> -->

                  <div class="row mb-3" v-show="permision_role.method_read">
                    <div class="col-lg-12">
                      <div class="col-lg-12 mt-3">
                        <div class="card">
                          <div class="card-header">
                            <h4 style="margin-right: 5px" class="float-start">Multidrop</h4>
                            <button v-if="permision_role.method_create" type="button" :disabled="isLoading"
                              @click="createRow" class="btn-success btn btn-sm float-end">
                              <i class="link-icon" data-feather="plus"></i>
                              Tambah Baru
                            </button>

                          </div>
                          <div class="card-body">
                            <vue-good-table title="list-user" mode="remote" @on-page-change="onPageChange"
                              @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                              @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                              :isLoading.sync="isLoading" :pagination-options="{
                                enabled: true,
                              }" :rows="rows" :columns="columns">
                              <template slot="table-row" slot-scope="props">

                                <span v-if="props.column.field == 'actions'">
                                  <span v-show="props.row.edit == true">
                                    <a href="#" title="Edit" v-show="permision_role.method_update"
                                      @click.prevent="saveData(props.index, props.row)">
                                      <i class="mdi mdi-check" style="font-size: 16px"></i>
                                    </a>
                                  </span>

                                  <span v-show="props.row.edit == false">
                                    <a href="#" title="Edit" v-show="permision_role.method_update"
                                      @click.prevent="editData(props.index, props.row)">
                                      <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                                    </a>
                                    <a href="#" v-show="permision_role.method_delete" title="Delete"
                                      @click.prevent="deleteData(props.index, props.row)">
                                      <i class="mdi mdi-trash-can-outline" style="font-size: 16px"></i>
                                    </a>
                                  </span>
                                </span>

                                <span v-if="props.column.field == 'edi_code'">
                                  <span v-show="props.row.edit == true">
                                      {{ props.row.edi_code }} 

                                       <span @click="openTableB(props.row, props.index)"
                                            style="cursor:pointer; display:inline-flex; align-items:center; gap:4px; color:#3b82f6;">
                                            <i class="mdi mdi-magnify"
                                                style="font-size:16px;"></i>
                                            Cari
                                        </span>
                                    
                                  </span>

                                  <span v-show="props.row.edit == false">
                                    {{ props.row.edi_code }}
                                  </span>
                                </span>

                                 <span v-if="props.column.field == 'charge_code_description'">
                                  <span v-show="props.row.edit == true">
                                      <input class="form-control" readonly name="charge_code_decription" v-model="props.row.charge_code_description" />
                                    
                                  </span>

                                  <span v-show="props.row.edit == false">
                                    {{ props.row.charge_code_description }} 
                                  </span>
                                </span>

                                <span v-if="props.column.field == 'method'">
                                  <span v-show="props.row.edit == true">

                                    <v-select :options="fetchMethod" v-model="props.row.method"
                                      v-bind:style="{ padding: 0 }" class="form-control"  ></v-select>

                                  </span>

                                  <span v-show="props.row.edit == false">
                                    {{ props.row.method }}
                                  </span>
                                </span>

                                <span v-if="props.column.field == 'truck_category'">
                                  <span v-show="props.row.edit == true">

                                    <v-select :options="fetchTypeTruck" v-model="props.row.truck_category"
                                      v-bind:style="{ padding: 0 }" class="form-control" label="type_truck"
                                      :reduce="(item) => item.type_truck" @search="asyncSearchTypeTruck"></v-select>

                                  </span>

                                  <span v-show="props.row.edit == false">
                                    {{ props.row.truck_category }}
                                  </span>
                                </span>

                                <span v-if="props.column.field == 'multidrop_amount'">
                                  <span v-show="props.row.edit == true">
                                    <input type="number" v-model="props.row.multidrop_amount" class="form-control">
                                  </span>

                                  <span v-show="props.row.edit == false">
                                    {{ props.row.multidrop_amount | format_number }}
                                  </span>
                                </span>

                              </template>
                            </vue-good-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        " @click="backForm" type="button">
                      <i class="link-icon" data-feather="arrow-left"></i>
                      {{ $t("backMess") }}
                    </button>
                    <!-- <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="sendToBlujay"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("sendToBlujay") }}
                      </button> -->

                    <!-- <a
                        v-if="permision_role.method_delete"
                        class="
                          btn btn-danger
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="deleteData()"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deleteMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a> -->
                  </div>
                  <!-- </form> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";


export default {
  name: "CompanyDetailMultidrop",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchMethod:[],
      userData: "",
      companyCode: "",
      companyName: "",
      forms: [],
      currentPage: 1,
      perPage: 10,

      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: "Action",
          field: "actions",
          width: "100px",
          sortable: false,
          filterOptions: {
            enabled: false
          }
        },


         {
          label: "EDI Code",
          field: "edi_code",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


         {
          label: "Charge Code",
          field: "charge_code_description",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

         {
          label: "Method",
          field: "method",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Truck Category",
          field: "truck_category",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Truck Category", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Multidrop Amount",
          field: "multidrop_amount",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Multidrop Amount", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        // {
        //   label: "Multidrop Number",
        //   field: "multidrop_number",
        //   filterOptions: {
        //     enabled: true, // enable filter for this column
        //     placeholder: "Filter By Multidrop Number", // placeholder for filter input
        //     filterValue: "", // initial populated value for this filter
        //     filterDropdownItems: [], // dropdown (with selected values) instead of text input
        //     trigger: "enter", //only trigger on enter not on keyup
        //   },
        // },

      ],
      rows: [],
      type: "add",
      showModal: false,
      showModalList: false,
      data: '',
      permision_role2: [],
      fetchTypeTruck: [],
      fetchChargeCode:[],
      selectedIndexA:null,
      selectedRow:null,
    };
  },
  watch: {},
  methods: {
    createRow() {
      this.rows.push({
        edit: true,
        isCreate: true,
        company_id: this.forms.company_id,
        truck_category: null,
        multidrop_amount: 0,
        multidrop_number: 0,
        edi_code:null,
        method:null,
        charge_code_description:null,
      });
    },
    resetForm() {
      this.forms.code = "";
      this.forms.name = "";
      this.forms.country = "";
      this.forms.province = "";
      this.forms.city = "";
      this.forms.area = "";
      this.forms.sub_area = "";
      this.forms.village = "";
      this.forms.address = "";
      this.forms.postal_code = "";
      this.forms.status = "";
      this.forms.pic_name = "";
      this.forms.pic_email = "";
      this.forms.pic_phone = "";
    },


    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData(index, row) {
      row.edit = true;
      // this.rows[index]['edit'] = true;
    },
    async saveData(index, row) {
      this.isLoading = true;
      if (row.isCreate) {
        let id = await this.createNewMultidrop(row);
        if (id) {
          row.company_multidrop_id = id;
          this.$delete(row, 'isCreate');
          row.edit = false;
        }
        this.loading();
      } else {
        let check = await this.updateMultidrop(row);
        if(check){
          row.edit = false;
        }
        this.loading();

      }

    },
    async createNewMultidrop(payload) {
      const baseURI = this.$settings.endPoint + "company-multidrop/create/";
      return this.$http
        .post(baseURI, payload)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {

            this.$swal({
              icon: "success",
              title: "Record Has Been Saved !!!"
            });
            return response.data.datas.company_multidrop_id;
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
            return false;
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          return false;
        });
    },




        openTableB(row, indexA) {
            
              this.selectedRow = row;        // simpan row object
              this.selectedIndexA = indexA;

            let htmlTable = `
        <div>
            <input type="text" id="searchChargeCode" class="form-control mb-2" 
                placeholder="Ketik untuk cari (enter untuk load dari API)..." />
            <div id="tableWrapper" class="table-responsive" style="max-height:300px; overflow-y:auto;">
                ${this.renderChargeCodeTable()}
            </div>
        </div>
    `;

            this.$swal.fire({
                title: "Pilih Salah Satu",
                html: htmlTable,
                showConfirmButton: false,
                backdrop: true,
                customClass: {
                    popup: 'p-0 shadow-none rounded-lg bg-white'
                },
                width: 700,
                didOpen: () => {
                    // Event pencarian -> tekan Enter untuk request API
                    const searchInput = document.getElementById("searchChargeCode");
                    searchInput.addEventListener("keypress", async (e) => {
                        if (e.key === "Enter") {
                            const keyword = e.target.value;
                            await this.asyncChargeCode(keyword); // ambil data baru dari API
                            document.getElementById("tableWrapper").innerHTML = this.renderChargeCodeTable();
                            this.bindSelectEvent(); // binding ulang tombol "Pilih"
                        }
                    });

                    // binding awal
                    this.bindSelectEvent();
                }
            });
        },

        // render tabel (biar bisa dipanggil ulang setelah API call)
        renderChargeCodeTable() {
            return `
        <table id="tableB" class="table table-bordered table-striped table-hover table-sm mb-0">
            <thead class="table-dark">
                <tr>
                    <th>EDI Code</th>
                    <th>Charge Code</th>
                    <th>Description Override</th>
                    <th>Aksi</th>
                </tr>
            </thead>
            <tbody>
                ${this.fetchChargeCode.map((row, j) => `
                    <tr>
                        <td>${row.edi_code}</td>
                        <td>${row.charge_code}</td>
                        <td>${row.description_overide}</td>
                        <td>
                            <button data-index="${j}" 
                                class="btn btn-sm btn-primary btn-pilih">
                                Pilih
                            </button>
                        </td>
                    </tr>
                `).join('')}
            </tbody>
        </table>
    `;
        },

        // binding tombol pilih
        bindSelectEvent() {
            const buttons = document.querySelectorAll('#tableB .btn-pilih');
            buttons.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const indexB = e.target.getAttribute("data-index");
                    this.selectFromB(parseInt(indexB));
                });
            });
        },

        // asyncChargeCode(ev) {
        //     this.fetchChargeCode = [];
        //     const baseURI =
        //         this.$settings.endPoint + `rm-charge-code?description_overide=` + ev;
        //     return this.$http.get(baseURI).then((response) => {
        //         this.fetchChargeCode = response.data.datas.data;
        //     });
        // },

        selectFromB(indexB) {
            const selectedData = this.fetchChargeCode[indexB];

            // update baris yang dipilih di vue-good-table
            this.rows[this.selectedIndexA].edi_code = selectedData.edi_code;
            this.rows[this.selectedIndexA].charge_code_description = selectedData.description_overide;
            this.rows[this.selectedIndexA].edit=true;
            this.$swal.close();
        },




         loadChargeCode() {
            this.fetchChargeCode = [];
            const baseURI = this.$settings.endPoint + `rm-charge-code`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchChargeCode = response.data.datas.data;
            });
        },

        asyncChargeCode(ev) {
            this.fetchChargeCode = [];
            const baseURI =
                this.$settings.endPoint + `rm-charge-code?description_overide=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchChargeCode = response.data.datas.data;
            });
        },


    async updateMultidrop(payload){
      const baseURI = this.$settings.endPoint + "company-multidrop/update/"+payload.company_multidrop_id;
        return this.$http
        .patch(baseURI, payload)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.$swal({
              icon: "success",
              title: "Record Has Been Saved !!!"
            });
            return true;
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
            return false;
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          return false;
        });

    },
    deleteData(index, row) {
      this.isLoading = true;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI = this.$settings.endPoint + "company-multidrop/delete/" + row.company_multidrop_id;
          this.$http
            .delete(baseURI)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.rows.splice(index,1);
                this.$swal({
                  icon: "success",
                  title: "Record Has Been Deleted !!!"
                });
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },
    sendToBlujay() {

    },
    backForm() {
      window.location.href = "/company";
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI = this.$settings.endPoint + "company/detail/" + id;
      return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        this.isLoading = false;
        this.forms = response.data.datas;

        this.companyName = this.forms.name
        this.loadItems();
        // this.form={ name: 'asep', usernmae:res.username };
      }).catch(error => {
        this.isLoading = false;
        if (error.code == "ECONNABORTED") {
          this.error("Please Check Your Internet Connection");
        } else {

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }

        }


      });
    },


    loadMethod() {
        const baseURI =
            this.$settings.endPointCt + `master-lookup?unique_id=mtAdd`;
        return this.$http.get(baseURI).then((response) => {
            this.fetchMethod = response.data.datas;
        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'CompanyMultidropController') {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);
          // let params = this.$onBehind(this.$route.params.id);
          // let formData = new FormData();
          // formData.append("name", this.forms.name);
          // formData.append("username", this.forms.username);
          // formData.append("password", this.forms.password);
          // formData.append("email", this.forms.email);
          // formData.append("company_id", this.forms.company_id);
          // formData.append("role_id", this.forms.role_id);
          // formData.append("status", 'active');

          const baseURI =
            this.$settings.endPoint + "company/update/" + this.forms.company_id;
          this.$http
            .patch(baseURI, this.forms)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.resetForm();
                this.errors = [];
                this.success(response.data.datas.messages);

                //window.history.back();
                var params = this.$onRandom(this.forms.company_id);
                window.location.href = "/company/detail/" + params;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
              this.resetForm();
            });
        }
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    editDataCost(index, row) {
      this.showModal = true;
      this.data = {
        company_id: this.forms.company_id,
        company_name: this.forms.name,
        charge_header: row
      };
      this.type = "edit";
    },
    createCost() {
      this.showModal = true;
      this.data = {
        company_id: this.forms.company_id,
        company_name: this.forms.name,
      };
      this.type = "add";
    },
    showDetailCharge(ev) {
      this.showModalList = true;
      this.data = ev;
    },


    closeMyModal() {
      this.showModal = false;
      this.showModalList = false;
      this.loadItems();
    },


    deleteDataCost(index, row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI = this.$settings.endPointProformaInvoice + "v1/company-cost/delete/" + row.charge_code_header_id;

          this.$http
            .delete(baseURI)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    createData() {
      window.location.href = "/master-customer-ct/add";
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },
    async loadItems() {
      const baseURI = this.$settings.endPoint + "company-multidrop";

      //var columnFilters = this.serverParams.columnFilters;
      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&company_id=${this.forms.company_id}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&truck_category=${this.serverParams.columnFilters.truck_category}&multidrop_amount=${this.serverParams.columnFilters.multidrop_amount}&multidrop_number=${this.serverParams.columnFilters?.multidrop_number ? this.serverParams.columnFilters?.multidrop_number : ''}`,
        )
        .then((response) => {

          this.rows = [];
          let responses = response.data.datas.data;
          responses.forEach((item) => {
            let arr = item;
            arr['edit'] = false;
            this.rows.push(arr);
          });
          // this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        });
    },
    loadTypeTruck() {
      const baseURI = this.$settings.endPointCt + `type-truck/select`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchTypeTruck = response.data.datas.data;
      });
    },
    asyncSearchTypeTruck(search) {
      this.fetchTypeTruck = [];
      const baseURI =
        this.$settings.endPointCt +
        `type-truck/select?type_truck=${search}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchTypeTruck = response.data.datas.data;
      });
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.loadTypeTruck();
    this.loadMethod();
    this.loadChargeCode();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>